export default "__VITE_ASSET__BGPKJHIw__"